import { forwardRef } from '@chakra-ui/react';
import { Typography } from '@shinetools/sunshine-universal';

import { Cell, type CellProps } from './Cell';

export type CellTextProps = CellProps;

export const CellText = forwardRef<CellTextProps, 'div'>((props, ref) => {
  const { __css: css, ...rest } = props;

  return (
    <Cell {...rest} ref={ref}>
      <Typography.Text>{rest.children}</Typography.Text>
    </Cell>
  );
});
